// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__kyva1","header":"MessagesList_header__kTQga","chat":"MessagesList_chat__1L_Ey"};